import { Box, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getModulesRequest } from '@pages/modules/store';
import Topbar from './Topbar/Topbar';
import Sidebar from './Sidebar/Sidebar';
import { Outlet } from 'react-router-dom';

export const Layout = () => {
    const theme = useTheme();
    const dispatch = useDispatch();

    // requests for global required data
    useEffect(() => {
        dispatch(getModulesRequest());
    }, [dispatch]);

    return (
        <>
            <Topbar />
            <Box sx={{ background: (theme.palette as any).components.navigation.background }} className="App">
                <Sidebar />
                <Box sx={{ background: theme.palette.background.default }} className="AppContent">
                    <Outlet />
                </Box>
            </Box>
        </>
    );
};
